import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import './css/favorisClient.css';
import Spinner from "react-bootstrap/Spinner";
import noImage from "../../Image/no-image.jpg";
import { BASE_URL } from "../../Utils/base_url";
import { SuprimerFavorite, AfficheFavorite } from '../../Api/ClientApi/FaravorisApi';

const Favoris = () => {
    const [loadData, setLoadData] = useState([]);
    const [data, setData] = useState([]);

    let location = useLocation();
    let navigate = useNavigate();

    const client = useSelector((state) => state.client);

    useEffect(() => {
        AfficheFavorisClient();
    }, []);

    const AfficheFavorisClient = () => {
        setLoadData(true);
        AfficheFavorite(client.id)
            .then(function (response) {
                console.log("dataFavoris =>", response.data.donner);
                setData(response.data.donner);
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                setLoadData(false);
            });
    };


    const viewPromotion = (promo) => {
        const existePromo50 = promo.find((el) => el.libelle === "Promotion de -50%");
        const existePromo40 = promo.find((el) => el.libelle === "Promotion de -40%");
        const existePromo30 = promo.find((el) => el.libelle === "Promotion de -30%");
        const existePromo20 = promo.find((el) => el.libelle === "Promotion de -20%");
        const existePromo10 = promo.find((el) => el.libelle === "Promotion de -10%");
        const existePromoSpecial = promo.find((el) => el.libelle === "Promotion : Menu spécial");

        if (existePromo50) {
            return (<label>-50%</label>);
        } else if (existePromo40) {
            return (<label>-40%</label>);
        } else if (existePromo30) {
            return (<label>-30%</label>);
        } else if (existePromo20) {
            return (<label>-20%</label>);
        } else if (existePromo10) {
            return (<label>-10%</label>);
        } else if (existePromoSpecial) {
            return (<label>Spécial</label>);

        } else {
            return (<p>Pas de promotion ...</p>);
        }


    }

    const safeParseFloat = (str) => {
        const value = Number.parseFloat(str);

        return Number.isNaN(value) ? 0 : value;
    };


    const viewFavoris = (item, index) => {


        const notes = safeParseFloat(
            item.notes.reduce(
                (prevNote, currentNote) => prevNote + parseInt(currentNote.note),
                0
            ) / item.notes.length
        );




        return (
            <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 d-flex justify-content-center' key={index}>

                <div className='items'>
                    <div className='box shadow'>
                        <div className='images'>
                            <div className='img'>
                                <img
                                    src={
                                        item.photos.length === 0
                                            ? noImage
                                            : BASE_URL + item.photos[0]?.urlPhoto
                                    }
                                    alt="logo restaurant"
                                />
                            </div>
                            <div className='category'>
                                <span>{item.typeCuisines[0].libelle}</span>
                            </div>
                        </div>
                        <div className='legend'>
                            <h3 className='title text-center'>{item.nomRestaurant}</h3>
                            {/* <h3 className='title'>{val.title.slice(0, 40)}...</h3> */}
                            <div className='sub_footer'>
                                <div>
                                    <i className='fa fa-bookmark'></i>
                                    <label>PM : {item.prixMoyenne[0].prix} Ar</label>
                                </div>
                                {item.promotions.length !== 0 ?
                                    <div className="reduction">
                                        <i className='fa fa-bullhorn'></i>
                                        {viewPromotion(item.promotions)}
                                    </div>
                                    : ""}

                            </div>
                            <div className="note_avis">
                                <div> <span className='note'>Note: {notes.toFixed(2)}/20</span></div>
                                <div><span className='avis'>Avis: {item.avis.length}</span></div>
                            </div>
                            <div className='footer_card'>
                                <div className='adresse'>
                                    <i className='fa fa-map-marker'></i>
                                    <label>{item.adresse}</label>
                                </div>

                                <div className='d-flex justify-content-between mt-2'>
                                    <button className='btn btn_suprimer' onClick={() => handleDelete(item.id)}>Suprimer</button>
                                    <Link to={`/restoPage/${item.id}`} title="page restaurant" className='btn btn_reserver'>Détails</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }



    const handleDelete = (id) => {
        setLoadData(true);
        const data = { idClient: client.id, idRestaurant: id };
        SuprimerFavorite(data)
            .then(function (response) {
                console.log(response.data.message);
                AfficheFavorisClient();
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                setLoadData(false);
            });
    }


    return (
        <div>
            <Helmet>
                <title>Favoris</title>
                <meta name='description' content='Favoris' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='favoris'>
                <div className='container'>
                    <div className='bloc_favoris'>
                        <div className='titre'>
                            <h1><i className='fa fa fa-tag'></i>Mes favoris</h1>
                        </div>
                        <div className='sous_titre'>
                            <h2>Retrouvez ici vos adresses préférées pour les avoirs à portée de main !
                                A consommer sans modération !
                            </h2>
                            <span>Nombre de favoris : {data.length === 0 ? "0" : data.length}</span>
                        </div>
                        <div className='favoris_content'>
                            <div className='row'>

                                {loadData === true ?
                                    <div className="d-flex justify-content-center">
                                        <Spinner
                                            animation="border"
                                            className="load"
                                            variant="info"
                                            size="md"
                                        />
                                    </div> : data.map((item, index) => {
                                        return viewFavoris(item, index);
                                    })
                                }

                            </div>
                        </div>

                        <p className="version">Version 1</p>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Favoris